<template>
  <div
    class="visit-block card"
    :class="{
      'canceled': visit.status === 'Odwołana',
    }"
  >
    <div
      class="auto-info"
      :class="{
        'hide': !showCarBlock
      }"
    >
      <car-block
        v-if="showCarBlock"
        :car="car"
        mode="visit"
      />
    </div>
    <div class="visit-info">
      <div
        class="visit-info-element"
        v-if="visit.date"
      >
        <p class="label">
          Termin wizyty
        </p>
        <p class="visit-date">
          {{ formatDate(visit.date) }}
        </p>
      </div>
      <div
        class="visit-info-element"
      >
        <p class="label">
          Zakres usług
        </p>
        <p class="visit-type">
          <template v-for="(service, index) in visit.services">
            <span
              :key="'type' + index"
            >
              {{ service.name }}
            </span>
            <img
              :key="'image' + index"
              v-if="service.description && !isMobile"
              class="car-service-info-icon"
              v-tooltip.top="{ content: service.description, classes: 'car-service-tooltip' }"
              src="../assets/icons/system-info-small.svg"
              alt=""
            >
            <span
              :key="'comma' + index"
              :class="{ 'left-margin': !service.description }"
            >
              {{ index === visit.services.length - 1 ? '' : ',' }}
            </span>
          </template>
        </p>
      </div>
      <div class="visit-info-element">
        <p class="label">
          Koszt wizyty
        </p>
        <p class="visit-cost">
          {{ visitCost !== '0.00 PLN' ? visitCost : '-' }}
        </p>
      </div>
    </div>
    <div class="aso-info">
      <service-station-block
        class="visit"
        :show-details="false"
        :show-page-link="isMobile"
        :service-station="getServiceStationByID(visit.asoID)"
        :with-slot="true"
      />
    </div>
    <div
      class="controls-container"
      :class="{
        'mobile': isMobile,
      }"
      v-if="type !== 'history'"
    >
      <button
        class="visit-control-button"
        v-if="visit.status !== 'Odwołana'"
        @click="buttonAction('new')"
        v-tooltip.left="{ content: 'Umów nową wizytę', classes: 'car-block-tooltip' }"
      >
        <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 17.5V21L7 23.5H4l-.5-.5L5 21.5l.5-1-2-2-1 .5L1 20.5.5 20v-3L3 14.5h3.5l8-8V3L17 .5h3l.5.5-1.8 1.7-.2.8 2 2 .8-.2L23 3.5l.5.5v3L21 9.5h-3.5z" stroke="currentColor" fill="none"/></svg>
      </button>
      <!--       <button
        class="visit-control-button"
        v-if="visit.status !== 'Odwołana'"
        @click="buttonAction('edit')"
        v-tooltip.left="{ content: 'Edytuj wizytę', classes: 'car-block-tooltip' }"
      >
        <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.8 4.2l6.6 3.1-2.6 5.5m-10.3 5l3.6 1.7m-3.6-1.7v4.7l3.6-3 7.5-16c.2-.3 0-.7-.3-.9l-2.4-1.1c-.3-.2-.7 0-.9.3l-7.5 16z" stroke="currentColor" fill="none"/></svg>
      </button> -->
      <button
        class="visit-control-button"
        v-if="visit.status !== 'Odwołana'"
        @click="openModal()"
        v-tooltip.left="{ content: 'Odwołaj wizytę', classes: 'car-block-tooltip' }"
      >
        <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 9v10.5c0 .5.4 1 1 1h10c.5 0 1-.5 1-1V9m-6-3.5v-2m-1.5 0h3m-9.5 4h16l-1.4-2H4.9l-1.4 2z" stroke="currentColor" fill="none"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import ServiceStationBlock from '~/ServiceStationBlock';
import CarBlock from '~/CarBlock';
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    visit: {
      type: Object,
      default: () => {},
    },
    car: {
      type: Object,
      default: () => {},
    },
    serviceStation: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    showCarBlock: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      serviceStations: 'serviceStations/getServiceStations',
      allModels: 'brand/getSpecificModels',
    }),
    buttonText() {
      if (this.type === 'next' && this.visit.status !== 'Odwołana') {
        return 'Odwołaj wizytę';
      } if (this.type === 'next' && this.visit.status === 'Odwołana') {
        return 'Odwołana';
      }
      return 'Nowa wizyta';
    },
    getModelID() {
      if (this.car) {
        return this.allModels.find(model => model.name === this.car.name
            && model.transmission === this.car.transmission
            && model.power === this.car.power
            && model.capacity === this.car.capacity);
      }
      return null;
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    visitCost() {
      return `${this.visit.grossPrice.toFixed(2)} PLN`.replace('.', ',');
    },
  },
  components: {
    CarBlock,
    ServiceStationBlock,
  },
  methods: {
    ...mapActions({
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      toggleModal: 'modal/openModal',
      setModalMode: 'modal/setModalMode',
      setModalStep: 'modal/setModalStep',
      setCarID: 'visit/setSelectedCarModelID',
      setLicensePlate: 'visit/setSelectedLicensePlate',
      setVinNumber: 'visit/setSelectedVin',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedPrice: 'visit/setPrice',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedVin: 'visit/setSelectedVin',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setMileage: 'visit/setMileage',
    }),
    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY hh:mm');
    },
    getServiceStationByID(id) {
      return this.serviceStations.find(station => station.id === id);
    },
    buttonAction(type) {
      if (type === 'new') {
        this.$router.push({ path: `/dashboard/visits/new/${this.getModelID.id}/station` });

        this.resetVisitSpecs();
        this.setSelectedCarModelID(this.getModelID.id);
        this.setSelectedLicensePlate(this.car.licensePlate);
        this.setSelectedVin(this.car.vin);
      } else if (type === 'edit') {
        this.$router.push({ path: `/dashboard/visits/edit/${this.getModelID.id}/station` });

        this.setSelectedCarModelID(this.getModelID.id);
        this.setSelectedLicensePlate(this.car.licensePlate);
        this.setSelectedVin(this.car.vin);
        this.setSelectedPartner(this.getServiceStationByID(this.visit.asoID));
        this.setSelectedVisitDate({
          day: dayjs(this.visit.date).format('YYYY-MM-DD'),
          time: dayjs(this.visit.date).format('hh:mm'),
        });
        this.setSelectedServices(this.visit.services);
        this.setRegisteredVisit(this.visit);
      }
    },
    openModal() {
      this.setModalContent({
        title: 'Odwołaj wizytę',
        additional: {
          visit: this.visit,
        },
      });
      this.setModalMode('logged-in');
      this.setModalStep('cancel_visit');
      this.toggleModal();
    },
    resetVisitSpecs() {
      this.setSelectedPartner(null);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);
      this.setRegisteredVisit(null);
      this.setMileage(0);
    },
  },
};
</script>
